import { useState } from "react";
import { useHistory } from "react-router";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useLazyFindServiceProviderQuery } from "@monorepo/services/api/services";
import { reverse } from "named-urls";

export const getTemplateServiceRoute = (activeServiceId: string, templateId?: string) =>
  templateId
    ? reverse(routeConfig.dashboard.payments.addService.template.service.edit.self, {
        serviceId: activeServiceId,
        templateId,
      })
    : reverse(routeConfig.dashboard.payments.addService.template.service.self, {
        serviceId: activeServiceId,
      });

export const getRecurrentPaymentRoute = (activeServiceId: string) =>
  reverse(routeConfig.dashboard.payments.addService.recurringPayments.service.self, {
    serviceId: activeServiceId,
  });

export const useFindServiceProvider = (recipient: string, templateId?: string, isRecurringPayment?: boolean) => {
  const [findServiceProvider] = useLazyFindServiceProviderQuery();
  const [altPayment, setAltPayment] = useState<Array<any>>([]);
  const history = useHistory();

  return {
    findServiceProviderAction: (onSubmit: () => Promise<any>, keywords: string) => {
      findServiceProvider({ keywords: keywords?.trim() }).then((response) => {
        const responseData = response.data;

        if (Array.isArray(responseData) && responseData?.length) {
          setAltPayment(responseData);

          return;
        }

        return onSubmit();
      });
    },
    altPayment,
    setAltPayment,
    confirmAction: () => {
      if (altPayment.length === 1) {
        if (templateId) {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.template.service.edit.self, {
              serviceId: altPayment[0].id,
              templateId,
            })
          );
        } else if (isRecurringPayment) {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.recurringPayments.service.self, {
              serviceId: altPayment[0].id,
            })
          );
        } else {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.template.service.self, {
              serviceId: altPayment[0].id,
            })
          );
        }
      } else {
        if (templateId) {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.template.providers.edit.self, {
              providers: recipient,
              templateId,
            })
          );
        } else if (isRecurringPayment) {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.recurringPayments.providers.self, {
              providers: recipient,
            })
          );
        } else {
          history.push(
            reverse(routeConfig.dashboard.payments.addService.template.providers.self, {
              providers: recipient,
            })
          );
        }
      }
    },
    declineAction: () => setAltPayment([]),
  };
};
